module.exports = __webpack_public_path__ + "static/media/underline.ec49a423.svg";